import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './app/App';
import reportWebVitals from './reportWebVitals';
import { I18nextProvider } from 'react-i18next';
import i18next from 'i18next';
import common_en from './translations/en/common.json';
import mvp_en from './translations/en/mvp.json';
import dentaquest_en from './translations/en/dentaquest.json';
import ahc_en from './translations/en/ahc.json';
import ahcadmin_en from './translations/en/ahcadmin.json';
import transport_en from './translations/en/transport.json';

import '@fontsource/source-sans-pro/400.css';
import '@fontsource/source-sans-pro/600.css';
import '@fontsource/source-sans-pro/700.css';
import '@fontsource/bitter/700.css';
import { initializeFullStory } from './services/fullStory';

i18next.init({
  interpolation: { escapeValue: false },
  lng: 'en',
  ns: ['common', 'mvp', 'dentaquest', 'ahc', 'ahcadmin', 'transport'],
  fallbackNS: 'common',
  resources: {
    en: {
      common: common_en,
      mvp: mvp_en,
      dentaquest: dentaquest_en,
      ahc: ahc_en,
      ahcadmin: ahcadmin_en,
      transport: transport_en,
    },
  },
});

void initializeFullStory();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18next}>
      <App />
    </I18nextProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
